export const baseUrl = process.env.REACT_APP_BACKEND_URL
//export const baseUrl = 'http://localhost:7000'
// export const baseUrl = 'https://p5jkb59d-7000.inc1.devtunnels.ms'
//prod
// export const baseUrl = 'https://9klptqlv-7000.inc1.devtunnels.ms'
export const frontEndBaseUrl = process.env.REACT_APP_FRONTEND_URL
